
import React from 'react'
import {Link} from 'gatsby'
import { 
    Container, 
    List, 
    Segment,
} from "semantic-ui-react";


export default ()=> {

    const link_style = {
        color: "rgba(255,255,255,0.5)",
        // ":hover": {
        //     color: "#fff"
        // }
    }
    return (
        <footer>
            <Segment inverted vertical style={{ margin: '0em 0em 0em' }}>
                <Container textAlign='center'>
                    <List horizontal inverted divided link size="small" >
                        { /*
                        <List.Item  as='a' href='#'>
                            Site Map
                        </List.Item>

                        */}
                        <List.Item >
                            <Link to="/downloads">
                                <span style={ link_style }>Downloads</span>
                            </Link>
                        </List.Item>
                        <List.Item >
                            <Link to="/terms-of-use">
                                <span style={ link_style }>Terms of use</span>
                            </Link>
                        </List.Item>
                        <List.Item as='a' href='/privacy'>
                            <Link to="/privacy">
                                <span style={ link_style }>Privacy</span>
                            </Link>
                        </List.Item>
                        <List.Item>
                        <Link to="/contact-us">
                                <span style={ link_style }>Contact Us</span>
                            </Link>
                        </List.Item>
                    </List>            
                    <List link inverted>
                        <List.Item as='a' href='#'>
                            © {new Date().getFullYear()}, PatternMaker Software
                        </List.Item>
                    </List>   
                </Container>
            </Segment>
        </footer>
    )
}
